
import Vue from 'vue'
import Router from 'vue-router'

import { store } from '../main.js'

import Login from './login'
import Home from './home'
import Users from './users'
import Trial from './trial'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: "active",
    hashbang: false,
    routes: [
        Login,
        Home,
        Users,
        Trial
    ],
    scrollBehavior() {
        document.getElementById('app').scrollIntoView();
    }
});

router.beforeEach((to, from, next) => {

    const authenticated = localStorage.getItem('token');

    if (!authenticated && to.path.toString() != '/login' && to.path.toString() != '/trial-invitee') {

        if (to.path != '/' && to.path != '/notAllowed') {
            next('/login?url=' + to.path);

        } else if (to.path == '/notAllowed') {
            next('/notAllowed');
        } else {
            next('/login');
        }
        return true;
    }

    if (authenticated && to.path.toString() == '/login') {

        return true;
    }

    next();
});

router.afterEach((to, from) => {
    let _name = to.name;
    let _route = to.fullPath;

    if (_name === 'Home') {
        _name = '';
        _route = '';
    }

    store.commit("updateBreadCrumbs", { name: _name, route: _route })
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js